module.exports = __webpack_public_path__ + "pc/img/brand04.23b5dc87.png";